<template>
    <div class="homepage">
        欢迎访问商家系统
    </div>
</template>
<style rel="stylesheet/css" lang="postcss" scoped>
    .homepage{
        text-align: center;
        display: flex;
        align-self: center;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        font-size: 18px;
    }
</style>

<script>
    import { mapActions } from 'vuex'
    export default {
        data () {
            return {
            }
        },

        methods: {
            ...mapActions(['getUser'])
        },
        mounted () {

        }
    }
</script>



// WEBPACK FOOTER //
// Home.vue?170f4d2c